module.exports = __webpack_public_path__ + "static/assets/18056077bf422ed8150fee10c2f494ad.gif";